import { createContext, useContext, useState, ReactNode } from 'react'

type Language = 'tr' | 'en'

interface LanguageContextType {
  language: Language
  setLanguage: (lang: Language) => void
  t: (key: string) => string
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined)

const translations: Record<Language, Record<string, string>> = {
  tr: {
    'nav.home': 'Ana Sayfa',
    'nav.packages': 'Paketler',
    'nav.portfolio': 'Portföy',
    'nav.cart': 'Sepet',
    'hero.slide1.title': 'Modern Web Tasarımı',
    'hero.slide1.subtitle': 'Yenilikçi ve kullanıcı dostu web siteleri ile dijital varlığınızı güçlendirin',
    'hero.slide2.title': 'E-Ticaret Çözümleri',
    'hero.slide2.subtitle': 'Online satışlarınızı artıran, güvenli ve hızlı e-ticaret platformları',
    'hero.slide3.title': 'Mobil Uyumlu Tasarım',
    'hero.slide3.subtitle': 'Tüm cihazlarda mükemmel görünen, responsive ve modern arayüzler',
    'hero.slide4.title': 'SEO Optimizasyonu',
    'hero.slide4.subtitle': 'Arama motorlarında üst sıralarda yer alın, daha fazla müşteriye ulaşın',
    'hero.slide5.title': 'Özel Yazılım Geliştirme',
    'hero.slide5.subtitle': 'İhtiyacınıza özel çözümler ile iş süreçlerinizi dijitalleştirin',
    'hero.slide6.title': 'Dijital Dönüşüm',
    'hero.slide6.subtitle': 'Profesyonel web çözümleri ile işinizi bir adım öne taşıyın',
    'hero.cta1': 'Portföy',
    'hero.cta2': 'Paketler',
    'packages.pill': 'Paketlerimiz',
    'packages.title': 'Paket Özellikleri',
    'packages.subtitle': 'İhtiyacınıza uygun paketi seçin ve hemen başlayın',
    'packages.createSite': 'Kendi Siteni Oluştur',
    'packages.package1': 'Kurumsal Basit Site',
    'packages.package1Desc': 'Profesyonel kurumsal kimliğinizi dijital dünyaya taşıyın. Modern tasarım, hızlı yükleme ve SEO optimizasyonu ile markanızı öne çıkarın.',
    'packages.package2': 'İçerik Yönetim Sitesi',
    'packages.package2Desc': 'İçeriklerinizi kolayca yönetin ve organize edin. Kategori yönetimi ve gelişmiş arama özellikleri ile işinizi kolaylaştırın.',
    'packages.package3': 'E-Ticaret Sitesi',
    'packages.package3Desc': 'Online satışlarınızı artırın, müşterilerinize ulaşın. Güvenli ödeme, sepet yönetimi ve kargo entegrasyonu ile tam kapsamlı e-ticaret deneyimi.',
    'portfolio.pill': 'Portföyümüz',
    'portfolio.title': 'Yaptığımız Websiteleri',
    'portfolio.subtitle': 'Başarıyla tamamladığımız projelerimizden örnekler',
    'portfolio.preview': 'Önizle',
    'footer.copyright': 'Tüm hakları saklıdır.',
    'builder.pill': 'Özel Tasarım',
    'builder.title': 'Kendi Sitenizi Oluşturun',
    'builder.subtitle': 'İhtiyacınıza göre modülleri seçin ve özel sitenizi oluşturun',
    'builder.basePrice': 'Temel Fiyat',
    'builder.modules': 'Modüller',
    'builder.total': 'Toplam',
    'builder.category.basic': 'Temel Özellikler',
    'builder.category.siteInfo': 'Site Bilgileri',
    'builder.category.features': 'Özellikler',
    'builder.category.integrations': 'Entegrasyonlar',
    'builder.category.management': 'Yönetim',
    'builder.free': 'Ücretsiz',
    'builder.companyName': 'Şirket Adı',
    'builder.companyNamePlaceholder': 'Şirket Adı',
    'builder.companyDescription': 'Şirket Açıklaması',
    'builder.companyDescriptionPlaceholder': 'Şirketinizin ne yaptığını kısaca açıklayın',
    'builder.companyDescriptionHint': 'Şirketinizin ne yaptığını kısaca açıklayın (örn: Web tasarım hizmetleri, E-ticaret platformu, vb.)',
    'builder.domain': 'Alan Adı (Domain)',
    'builder.domainPlaceholder': 'ornek.com',
    'builder.theme': 'Tema Seçimi',
    'builder.themeDark': 'Koyu Tema',
    'builder.themeLight': 'Açık Tema',
    'builder.colors': 'Renkler * (Min: 1, Max: 5)',
    'builder.removeColor': 'Renk Sil',
    'builder.contactInfo': 'İletişim Bilgileri',
    'builder.firstName': 'Ad',
    'builder.firstNamePlaceholder': 'Adınız',
    'builder.lastName': 'Soyad',
    'builder.lastNamePlaceholder': 'Soyadınız',
    'builder.phone': 'Telefon',
    'builder.phonePlaceholder': '05XX XXX XX XX',
    'builder.email': 'E-posta',
    'builder.emailPlaceholder': 'email@example.com',
    'builder.selectedModules': 'Seçilen Modüller',
    'builder.submit': 'Siparişi Gönder',
    'builder.submitting': 'Gönderiliyor...',
    'builder.submitSuccess': 'Sipariş Gönderildi!',
    'builder.alert.fillFields': 'Lütfen ad, soyad ve telefon alanlarını doldurun!',
    'builder.alert.error': 'Sipariş gönderilirken bir hata oluştu. Lütfen tekrar deneyin.',
    'builder.module.seo': 'SEO Optimizasyonu',
    'builder.module.seoDesc': 'Arama motoru optimizasyonu ile sitenizi üst sıralara taşıyın',
    'builder.module.appointment': 'Randevu Sistemi',
    'builder.module.appointmentDesc': 'Online randevu alma ve yönetim sistemi',
    'builder.module.contactEmail': 'İletişim Mail Formu',
    'builder.module.contactEmailDesc': 'Müşterilerinizden direkt mail alın',
    'builder.module.whatsapp': 'WhatsApp İkonu',
    'builder.module.whatsappDesc': 'WhatsApp iletişim butonu ve entegrasyonu',
    'builder.module.adminPanel': 'Admin Paneli',
    'builder.module.adminPanelDesc': 'Gelişmiş içerik yönetim paneli',
    'builder.module.multiLanguage': 'Çok Dilli Destek',
    'builder.module.multiLanguageDesc': 'Birden fazla dil desteği',
    'builder.module.blog': 'Blog Modülü',
    'builder.module.blogDesc': 'Haber ve blog yazıları için modül',
    'builder.module.gallery': 'Galeri Modülü',
    'builder.module.galleryDesc': 'Fotoğraf ve video galerisi',
    'builder.module.newsletter': 'E-Bülten Sistemi',
    'builder.module.newsletterDesc': 'E-posta bülteni ve abonelik sistemi',
    'builder.module.liveChat': 'Canlı Destek',
    'builder.module.liveChatDesc': 'Canlı sohbet ve destek sistemi',
    'builder.module.analytics': 'Analitik Entegrasyonu',
    'builder.module.analyticsDesc': 'Google Analytics ve detaylı istatistikler',
    'builder.module.socialMedia': 'Sosyal Medya Entegrasyonu',
    'builder.module.socialMediaDesc': 'Sosyal medya paylaşım butonları ve feed',
    'builder.module.map': 'Harita Entegrasyonu',
    'builder.module.mapDesc': 'Google Maps entegrasyonu ve konum gösterimi',
    'builder.module.video': 'Video Galerisi',
    'builder.module.videoDesc': 'Video içerik yönetimi ve oynatıcı',
    'builder.module.testimonials': 'Müşteri Yorumları',
    'builder.module.testimonialsDesc': 'Müşteri yorumları ve değerlendirme sistemi',
    'builder.module.faq': 'SSS Modülü',
    'builder.module.faqDesc': 'Sık sorulan sorular bölümü',
    'builder.module.search': 'Gelişmiş Arama',
    'builder.module.searchDesc': 'Gelişmiş arama ve filtreleme özellikleri',
    'cart.title': 'Sepetim',
    'cart.empty': 'Sepetiniz Boş',
    'cart.emptyDesc': 'Sepetinize henüz ürün eklenmemiş.',
    'cart.browsePackages': 'Paketleri İncele',
    'cart.remove': 'Kaldır',
    'cart.extraServices': 'Ekstra Hizmetler',
    'cart.service.security': 'Güvenlik Hizmeti',
    'cart.service.service': 'Servis Hizmeti',
    'cart.service.hosting': 'Hosting Hizmeti',
    'cart.monthly': '/ay',
    'cart.orderSummary': 'Sipariş Özeti',
    'cart.subtotal': 'Ara Toplam',
    'cart.extraServicesMonthly': 'Ekstra Hizmetler (Aylık)',
    'cart.vat': 'KDV',
    'cart.vatIncluded': 'Dahil',
    'cart.total': 'Toplam',
    'cart.monthlyNote': '* Ekstra hizmetler aylık ücretlendirilir',
    'cart.contactInfo': 'İletişim Bilgileri',
    'cart.firstName': 'Ad',
    'cart.firstNamePlaceholder': 'Adınız',
    'cart.lastName': 'Soyad',
    'cart.lastNamePlaceholder': 'Soyadınız',
    'cart.phone': 'Telefon Numarası',
    'cart.phonePlaceholder': '05XX XXX XX XX',
    'cart.submit': 'Siparişi Tamamla',
    'cart.submitting': 'Gönderiliyor...',
    'cart.submitSuccess': 'Sipariş Gönderildi!',
    'cart.alert.empty': 'Sepetiniz boş!',
    'cart.alert.fillFields': 'Lütfen tüm alanları doldurun!',
    'cart.alert.error': 'Sipariş gönderilirken bir hata oluştu. Lütfen tekrar deneyin.',
    'footer.description': 'Dijital dünyada fark yaratmak için profesyonel web çözümleri sunuyoruz. Modern tasarım, hızlı performans ve SEO optimizasyonu ile işinizi bir adım öne taşıyoruz.',
    'footer.quickLinks': 'Hızlı Linkler',
    'footer.services': 'Hizmetlerimiz',
    'footer.contact': 'İletişim',
    'footer.service1': 'Kurumsal Web Sitesi',
    'footer.service2': 'İçerik Yönetim Sistemi',
    'footer.service3': 'E-Ticaret Çözümleri',
    'modal.preview': 'Website Önizlemesi',
    'modal.visitSite': 'Siteyi Ziyaret Et',
    'studentApplication.welcomeTitle': 'Öğrenciyseniz Bizle Çalışın',
    'studentApplication.welcomeSubtitle': 'Öğrenciyseniz ve para karşılığı iş arıyorsanız Hazırım butonuna basın',
    'studentApplication.readyButton': 'Hazırım',
    'studentApplication.firstNameTitle': 'Adınızı Girin',
    'studentApplication.firstNameLabel': 'Adınız',
    'studentApplication.firstNameDescription': 'Size nasıl hitap edebiliriz',
    'studentApplication.firstNamePlaceholder': 'Adınız',
    'studentApplication.lastNameTitle': 'Soyadınızı Girin',
    'studentApplication.lastNameLabel': 'Soyadınız',
    'studentApplication.lastNameDescription': 'Bu da sizin kim olduğunuzu bilmemiz için lazım',
    'studentApplication.lastNamePlaceholder': 'Soyadınız',
    'studentApplication.phoneTitle': 'Telefon Numaranızı Girin',
    'studentApplication.phoneDescription': 'Size ulaşmanın en kolay yolu bu',
    'studentApplication.phonePlaceholder': '05XX XXX XX XX',
    'studentApplication.emailTitle': 'Öğrenci Emailı',
    'studentApplication.emailDescription': 'Öğrenci emaili dışında bir email girmeyin',
    'studentApplication.emailPlaceholder': 'ornek@universite.edu',
    'studentApplication.emailError': 'Lütfen .edu uzantılı bir e-posta adresi girin',
    'studentApplication.cursorTitleLabel': 'Cursor',
    'studentApplication.cursorTitle': 'Cursor ile websitesi yaptın mı?',
    'studentApplication.firebaseTitleLabel': 'Firebase',
    'studentApplication.firebaseTitle': 'Firebase ile hiçbir proje yaptın mı?',
    'studentApplication.imgbbTitleLabel': 'imgBB API',
    'studentApplication.imgbbTitle': 'imgBB API kullanıdınız mı?',
    'studentApplication.linkedinTitleLabel': 'LinkedIn',
    'studentApplication.linkedinTitle': 'LinkedIn\'de iş aramaktan sıkıldınız ve kesin aldığınız işler mi arıyorsunuz?',
    'studentApplication.projectTitleLabel': 'Proje',
    'studentApplication.projectTitle': 'Proje teslim ederek 1.5k - 3k kazanmayı mantıklı buluyor musunuz?',
    'studentApplication.cvTitle': 'CV\'niz',
    'studentApplication.cvTitleNew': 'CV Yükleyin',
    'studentApplication.cvDescription': 'CV nizi yüklerseniz geçmişinizdeki işlerinizi öğrenmek isteriz',
    'studentApplication.cvUpload': 'Ekle',
    'studentApplication.jokeText': 'Şaka yaptık',
    'studentApplication.finalMessage': 'Bize başvurmak için öğrenci olmanız yeterli.',
    'studentApplication.thankyouTitle': 'Teşekkürler!',
    'studentApplication.thankyouSubtitle': 'Bize ulaştığın için teşekkürler',
    'studentApplication.next': 'İleri',
    'studentApplication.yes': 'Evet',
    'studentApplication.no': 'Hayır',
    'studentApplication.answerPlaceholder': 'Cevabınızı yazın (max 20 karakter)',
    'studentApplication.submitting': 'Gönderiliyor...',
    'studentApplication.error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  },
  en: {
    'nav.home': 'Home',
    'nav.packages': 'Packages',
    'nav.portfolio': 'Portfolio',
    'nav.cart': 'Cart',
    'hero.slide1.title': 'Modern Web Design',
    'hero.slide1.subtitle': 'Strengthen your digital presence with innovative and user-friendly websites',
    'hero.slide2.title': 'E-Commerce Solutions',
    'hero.slide2.subtitle': 'Secure and fast e-commerce platforms that increase your online sales',
    'hero.slide3.title': 'Mobile Responsive Design',
    'hero.slide3.subtitle': 'Responsive and modern interfaces that look perfect on all devices',
    'hero.slide4.title': 'SEO Optimization',
    'hero.slide4.subtitle': 'Rank higher in search engines, reach more customers',
    'hero.slide5.title': 'Custom Software Development',
    'hero.slide5.subtitle': 'Digitize your business processes with custom solutions tailored to your needs',
    'hero.slide6.title': 'Digital Transformation',
    'hero.slide6.subtitle': 'Take your business one step ahead with professional web solutions',
    'hero.cta1': 'Portfolio',
    'hero.cta2': 'Packages',
    'packages.pill': 'Our Packages',
    'packages.title': 'Package Features',
    'packages.subtitle': 'Choose the package that suits your needs and get started',
    'packages.createSite': 'Create Your Site',
    'packages.package1': 'Corporate Simple Site',
    'packages.package1Desc': 'Bring your professional corporate identity to the digital world. Stand out with modern design, fast loading and SEO optimization.',
    'packages.package2': 'Content Management Site',
    'packages.package2Desc': 'Easily manage and organize your content. Simplify your business with category management and advanced search features.',
    'packages.package3': 'E-Commerce Site',
    'packages.package3Desc': 'Increase your online sales, reach your customers. Full-featured e-commerce experience with secure payment, cart management and shipping integration.',
    'portfolio.pill': 'Our Portfolio',
    'portfolio.title': 'Websites We Made',
    'portfolio.subtitle': 'Examples from our successfully completed projects',
    'portfolio.preview': 'Preview',
    'footer.copyright': 'All rights reserved.',
    'builder.pill': 'Custom Design',
    'builder.title': 'Create Your Own Site',
    'builder.subtitle': 'Select modules according to your needs and create your custom site',
    'builder.basePrice': 'Base Price',
    'builder.modules': 'Modules',
    'builder.total': 'Total',
    'builder.category.basic': 'Basic Features',
    'builder.category.siteInfo': 'Site Information',
    'builder.category.features': 'Features',
    'builder.category.integrations': 'Integrations',
    'builder.category.management': 'Management',
    'builder.free': 'Free',
    'builder.companyName': 'Company Name',
    'builder.companyNamePlaceholder': 'Company Name',
    'builder.companyDescription': 'Company Description',
    'builder.companyDescriptionPlaceholder': 'Briefly describe what your company does',
    'builder.companyDescriptionHint': 'Briefly describe what your company does (e.g., Web design services, E-commerce platform, etc.)',
    'builder.domain': 'Domain Name',
    'builder.domainPlaceholder': 'example.com',
    'builder.theme': 'Theme Selection',
    'builder.themeDark': 'Dark Theme',
    'builder.themeLight': 'Light Theme',
    'builder.colors': 'Colors * (Min: 1, Max: 5)',
    'builder.removeColor': 'Remove Color',
    'builder.contactInfo': 'Contact Information',
    'builder.firstName': 'First Name',
    'builder.firstNamePlaceholder': 'Your First Name',
    'builder.lastName': 'Last Name',
    'builder.lastNamePlaceholder': 'Your Last Name',
    'builder.phone': 'Phone',
    'builder.phonePlaceholder': '05XX XXX XX XX',
    'builder.email': 'Email',
    'builder.emailPlaceholder': 'email@example.com',
    'builder.selectedModules': 'Selected Modules',
    'builder.submit': 'Submit Order',
    'builder.submitting': 'Submitting...',
    'builder.submitSuccess': 'Order Submitted!',
    'builder.alert.fillFields': 'Please fill in the first name, last name and phone fields!',
    'builder.alert.error': 'An error occurred while submitting the order. Please try again.',
    'builder.module.seo': 'SEO Optimization',
    'builder.module.seoDesc': 'Move your site to the top ranks with search engine optimization',
    'builder.module.appointment': 'Appointment System',
    'builder.module.appointmentDesc': 'Online appointment booking and management system',
    'builder.module.contactEmail': 'Contact Email Form',
    'builder.module.contactEmailDesc': 'Receive direct emails from your customers',
    'builder.module.whatsapp': 'WhatsApp Icon',
    'builder.module.whatsappDesc': 'WhatsApp contact button and integration',
    'builder.module.adminPanel': 'Admin Panel',
    'builder.module.adminPanelDesc': 'Advanced content management panel',
    'builder.module.multiLanguage': 'Multi-Language Support',
    'builder.module.multiLanguageDesc': 'Support for multiple languages',
    'builder.module.blog': 'Blog Module',
    'builder.module.blogDesc': 'Module for news and blog posts',
    'builder.module.gallery': 'Gallery Module',
    'builder.module.galleryDesc': 'Photo and video gallery',
    'builder.module.newsletter': 'Newsletter System',
    'builder.module.newsletterDesc': 'Email newsletter and subscription system',
    'builder.module.liveChat': 'Live Support',
    'builder.module.liveChatDesc': 'Live chat and support system',
    'builder.module.analytics': 'Analytics Integration',
    'builder.module.analyticsDesc': 'Google Analytics and detailed statistics',
    'builder.module.socialMedia': 'Social Media Integration',
    'builder.module.socialMediaDesc': 'Social media share buttons and feed',
    'builder.module.map': 'Map Integration',
    'builder.module.mapDesc': 'Google Maps integration and location display',
    'builder.module.video': 'Video Gallery',
    'builder.module.videoDesc': 'Video content management and player',
    'builder.module.testimonials': 'Customer Reviews',
    'builder.module.testimonialsDesc': 'Customer reviews and rating system',
    'builder.module.faq': 'FAQ Module',
    'builder.module.faqDesc': 'Frequently asked questions section',
    'builder.module.search': 'Advanced Search',
    'builder.module.searchDesc': 'Advanced search and filtering features',
    'cart.title': 'My Cart',
    'cart.empty': 'Your Cart is Empty',
    'cart.emptyDesc': 'No products have been added to your cart yet.',
    'cart.browsePackages': 'Browse Packages',
    'cart.remove': 'Remove',
    'cart.extraServices': 'Extra Services',
    'cart.service.security': 'Security Service',
    'cart.service.service': 'Service Support',
    'cart.service.hosting': 'Hosting Service',
    'cart.monthly': '/month',
    'cart.orderSummary': 'Order Summary',
    'cart.subtotal': 'Subtotal',
    'cart.extraServicesMonthly': 'Extra Services (Monthly)',
    'cart.vat': 'VAT',
    'cart.vatIncluded': 'Included',
    'cart.total': 'Total',
    'cart.monthlyNote': '* Extra services are charged monthly',
    'cart.contactInfo': 'Contact Information',
    'cart.firstName': 'First Name',
    'cart.firstNamePlaceholder': 'Your First Name',
    'cart.lastName': 'Last Name',
    'cart.lastNamePlaceholder': 'Your Last Name',
    'cart.phone': 'Phone Number',
    'cart.phonePlaceholder': '05XX XXX XX XX',
    'cart.submit': 'Complete Order',
    'cart.submitting': 'Submitting...',
    'cart.submitSuccess': 'Order Submitted!',
    'cart.alert.empty': 'Your cart is empty!',
    'cart.alert.fillFields': 'Please fill in all fields!',
    'cart.alert.error': 'An error occurred while submitting the order. Please try again.',
    'footer.description': 'We offer professional web solutions to make a difference in the digital world. We take your business one step ahead with modern design, fast performance and SEO optimization.',
    'footer.quickLinks': 'Quick Links',
    'footer.services': 'Our Services',
    'footer.contact': 'Contact',
    'footer.service1': 'Corporate Website',
    'footer.service2': 'Product Management System',
    'footer.service3': 'E-Commerce Solutions',
    'modal.preview': 'Website Preview',
    'modal.visitSite': 'Visit Site',
    'studentApplication.welcomeTitle': 'Work With Us If You Are a Student',
    'studentApplication.welcomeSubtitle': 'If you are a student and looking for paid work, click the Ready button',
    'studentApplication.readyButton': 'Ready',
    'studentApplication.firstNameTitle': 'Enter Your First Name',
    'studentApplication.firstNameLabel': 'Your First Name',
    'studentApplication.firstNameDescription': 'How can we address you',
    'studentApplication.firstNamePlaceholder': 'Your First Name',
    'studentApplication.lastNameTitle': 'Enter Your Last Name',
    'studentApplication.lastNameLabel': 'Your Last Name',
    'studentApplication.lastNameDescription': 'This is needed for us to know who you are',
    'studentApplication.lastNamePlaceholder': 'Your Last Name',
    'studentApplication.phoneTitle': 'Enter Your Phone Number',
    'studentApplication.phoneDescription': 'This is the easiest way to reach you',
    'studentApplication.phonePlaceholder': '05XX XXX XX XX',
    'studentApplication.emailTitle': 'Enter Your .edu Email Address',
    'studentApplication.emailPlaceholder': 'example@university.edu',
    'studentApplication.emailError': 'Please enter an email address ending with .edu',
    'studentApplication.cursorTitleLabel': 'Cursor',
    'studentApplication.cursorTitle': 'Have you made a website with Cursor?',
    'studentApplication.firebaseTitleLabel': 'Firebase',
    'studentApplication.firebaseTitle': 'Have you made any project with Firebase?',
    'studentApplication.imgbbTitleLabel': 'imgBB API',
    'studentApplication.imgbbTitle': 'Have you used imgBB API?',
    'studentApplication.linkedinTitleLabel': 'LinkedIn',
    'studentApplication.linkedinTitle': 'Are you tired of looking for jobs on LinkedIn and looking for jobs you will definitely get?',
    'studentApplication.projectTitleLabel': 'Project',
    'studentApplication.projectTitle': 'Do you find it reasonable to earn 1.5k - 3k by delivering a project?',
    'studentApplication.cvTitle': 'Your CV',
    'studentApplication.cvTitleNew': 'Upload CV',
    'studentApplication.cvDescription': 'If you upload your CV, we would like to learn about your past work',
    'studentApplication.cvUpload': 'Add',
    'studentApplication.jokeText': 'Just kidding',
    'studentApplication.finalMessage': 'To apply to us, it is enough to be a student.',
    'studentApplication.thankyouTitle': 'Thank You!',
    'studentApplication.thankyouSubtitle': 'Thank you for reaching out to us',
    'studentApplication.next': 'Next',
    'studentApplication.yes': 'Yes',
    'studentApplication.no': 'No',
    'studentApplication.answerPlaceholder': 'Write your answer (max 20 characters)',
    'studentApplication.submitting': 'Submitting...',
    'studentApplication.error': 'An error occurred. Please try again.',
  }
}

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('language')
    return (saved === 'tr' || saved === 'en') ? saved : 'tr'
  })

  const t = (key: string): string => {
    return translations[language][key] || key
  }

  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang)
    localStorage.setItem('language', lang)
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

